import { Box, Typography } from "@mui/material";

interface DashboardPageTitleProps {
  title: string;
  color?: string;
}

/** Sticky page heading for analytics / KPI / inventory / customer dashboards */
export default function DashboardPageTitle({
  title,
  color = "#0F2744",
}: DashboardPageTitleProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        minHeight: { xs: 36, sm: 40 },
        width: "100%",
      }}
    >
      <Typography
        className="font-Saira"
        sx={{
          fontSize: { xs: 14, sm: 16, md: 18 },
          fontWeight: { xs: 600, sm: 700 },
          color,
          textAlign: "left",
          lineHeight: 1.2,
        }}
      >
        {title}
      </Typography>
    </Box>
  );
}
